<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import { Badge } from '@/components/ui/badge'
import { Title } from '@/components/ui/title'
import { event_end_day, event_month, event_start_day, event_year } from '@/helpers/event-date'

defineProps<{
    workshop: Workshop
    showButtoinDetails?: boolean
}>()
</script>

<template>
    <div class="flex flex-1 flex-col justify-center gap-4 text-white">
        <Badge class="w-fit bg-[#5b21b6]/30 hover:bg-[#5b21b6]/40">
            {{ $t('10% group discount') }}
        </Badge>

        <p
            v-html="
                $t('event_date', {
                    start: event_start_day(workshop.event_start_date),
                    end: event_end_day(workshop.event_end_date),
                    month: event_month(workshop.event_start_date),
                    year: event_year(workshop.event_start_date),
                })
            "
        ></p>

        <Title class="text-title font-semibold text-balance">
            {{ $t('International Supply Chain Forum & Expo.Logistics') }}
        </Title>

        <p>
            {{
                $t(
                    'Join the event that is transforming Brazilian logistics and shaping the future of the supply chain. At the ILOS Forum, you will find leading executives, players and academics discussing global trends, challenges and innovations that impact the sector.',
                    { event_description: $t(workshop.description) },
                )
            }}
        </p>

        <slot name="gallery"></slot>
    </div>
</template>
